export default __webpack_public_path__ + "static/media/salesperson.6be973f1.svg";